export const REGISTRATION_FORM_NAME = 'membershipRegistration'
